import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Engineering module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * No "coming soon" note. The route is gated by dept.engineering in allRoutes.js.
 */
const MODULES = ["dms", "tasks", "di", "app-mafia", "app-perflexion", "cr", "project", "epo", "app-tooltracker", "kpi"];

const Engineering = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-pencil-ruler-2-line"
                        eyebrow="Design"
                        title="Engineering"
                        subtitle="Drawings, BOMs, and design workflow"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Engineering" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="engineering" title="Engineering modules" icon="ri-pencil-ruler-2-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Engineering;
